export default __webpack_public_path__ + "static/media/Profile.1eb568a1.svg";